/**
 * flowMotionAtom.ts
 * フロー実行中のモーション情報を共有する Jotai atom
 * Gesture カード実行時に motionNo を設定し、VirtualRobot で再生して完了を待つ
 */
import { atom } from 'jotai';
import { completionOnce } from './completionOnce';
import type { TimelineData } from '../animation/animationUtils';

export interface FlowMotionInfo {
  motionNo: number;
  requestId: number;
  timeline?: TimelineData;
  physicsEnabled?: boolean;
  playBgm?: boolean;
  playNativeAudio?: boolean;
  onComplete?: () => void;
  onError?: (error: Error) => void;
}

/**
 * フロー実行中のモーション情報
 * Gesture カード実行時にセットされ、VirtualRobot がこれを監視して再生する
 * モーション完了時に onComplete コールバックが呼ばれる
 */
export const flowMotionAtom = atom<FlowMotionInfo | null>(null);

/**
 * 書き込み用 atom。
 * 前の要求が未完了のまま上書き、または null リセットされるとき、
 * 前の onComplete を必ず呼んでフロー側の待機を解決する。
 */
export const setFlowMotionAtom = atom(
  null,
  (get, set, next: FlowMotionInfo | null) => {
    get(flowMotionAtom)?.onComplete?.();
    set(flowMotionAtom, next ? { ...next, onComplete: completionOnce(next.onComplete) } : null);
  },
);
